<template>
	<div class="list-page">
		<div class="list-page__header">
			<span>房源信息</span>
		</div>
		<div class="list-page__content">
			<div
				class="house-content"
				v-for="house in houseList"
				:key="house.id"
			>
				<div class="house-content-left">
					<el-image
						:src="house.img"
						:preview-src-list="house.srcList || [house.img]"
						style="width: 250px; height: 160px; object-fit: cover"
					>
						<div slot="error" class="image-slot">
							<i class="el-icon-picture-outline"></i>
						</div>
						<div slot="placeholder" class="image-slot">
              <div class="el-loading-spinner"><svg viewBox="25 25 50 50" class="circular"><circle cx="50" cy="50" r="20" fill="none" class="path"></circle></svg><!----></div>
						</div>
					</el-image>
				</div>
				<div class="house-content-right">
					<p>
						<span class="house-content-right-label">位置:</span>
						<span class="house-content-right-name">{{
							house.place
						}}</span>
					</p>
					<p>
						<span class="house-content-right-label">面积:</span>
						<span class="house-content-right-name"
							>{{ house.area }}㎡</span
						>
					</p>
					<p>
						<span class="house-content-right-label">入驻要求:</span>
						<span class="house-content-right-name">{{
							house.requirement
						}}</span>
					</p>
					<p>
						<span class="house-content-right-label">联系人:</span>
						<span class="house-content-right-name">{{
							house.person
						}}</span>
					</p>
					<p>
						<span class="house-content-right-label">联系方式:</span>
						<span class="house-content-right-name">{{
							house.person_phone
						}}</span>
					</p>
				</div>
			</div>
		</div>
		<div class="list-page__footer">
			<el-pagination
				@current-change="handleCurrentChange"
				:current-page.sync="page"
				:page-size="limit"
				layout="prev, pager, next, jumper"
				:total="houseListTotal"
			>
			</el-pagination>
		</div>
	</div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
	props: {},
	data() {
		return {
			page: 1,
			limit: 10,
		}
	},
	computed: {
		...mapState('XMZS', ['houseList', 'houseListTotal']),
	},
	created() {
		this.fetchHouseList()
	},
	mounted() {},
	watch: {},
	methods: {
		...mapActions('XMZS', ['fetchHouseList']),
		handleCurrentChange(currentPage) {
			this.fetchHouseList({ page: currentPage, limit: 10 })
		},
	},
	components: {},
}
</script>

<style lang="scss">
.house {
	&-title {
		text-align: center;
		padding: 30px 0px;
		font-size: 28px;
		font-family: PingFangSC-Semibold, PingFang SC;
		font-weight: 600;
		color: rgba(0, 0, 0, 0.85);
		letter-spacing: 2px;
		border-bottom: 1px solid #f0f0f0;
	}
	&-content {
		padding: 24px 40px;
		display: flex;
		border-bottom: 1px solid #f0f0f0;
		&-right {
			margin-left: 20px;
			p {
				margin-bottom: 12px;
			}
			&-label {
				font-size: 16px;
				font-weight: 400;
				color: rgba(0, 0, 0, 0.45);
			}
			&-name {
				padding-left: 5px;
				font-size: 16px;
				font-weight: 500;
				color: rgba(0, 0, 0, 0.85);
			}
		}
		&:last-child {
			border: none;
		}
	}
}

.list {
	&-page {
		&__content {
			padding: 0;
		}
	}
}
</style>
